import {TokenScanner} from './token/tokenScaner.mjs';
import {NodeTreeBuilder} from './node/nodeTreeBuilder.mjs';
import {NodeJsonFormatter} from './node/nodeJsonFormatter.mjs';
import {tokenDefinitions} from './flavour/coursTree/lexical.mjs';
import {courseRules} from './flavour/coursTree/rules.mjs';

const scanner = new TokenScanner(tokenDefinitions);
const treeBuilder = new NodeTreeBuilder(courseRules);
const formatter = new NodeJsonFormatter();

function parseCoursMarkup(markup) {
    if (markup == null) return {units: []};
    if (typeof markup !== 'string') throw new TypeError('Course markup must be a string');
    return formatter.format(treeBuilder.buildNodeTree(scanner.scan(markup)));
}

export {parseCoursMarkup};
